import cloneDeep from 'lodash/fp/cloneDeep';
import SpinService from '../services/spinService';

const initialState = {
  spinSettings: {
    CMSpinPlayerURL: null,
  },
  spinError: null,
  isLoaded: false,
};

const getters = {};

const mutations = {
  SET_SPIN_SETTINGS(state, data) {
    state.spinSettings = data;
  },
  SET_SPIN_ERROR(state, data) {
    state.spinError = data;
  },
  SET_LOADED(state, data) {
    state.isLoaded = data;
  },
};

const actions = {
  async setSpinSettings({ rootState, commit }, vin) {
    const { business } = rootState;
    try {
      const res = await SpinService.getSpinSettings(business.api.key, business.api.externalID, vin);
      commit('SET_LOADED', true);
      commit('SET_SPIN_SETTINGS', res.data);
    } catch (error) {
      commit('SET_LOADED', true);
      commit('SET_SPIN_ERROR', true);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  mutations,
  actions,
  getters,
};
